import { useSignUpOwFApplication } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpOwFApplication";
import { IRetailerLaunchWithFaire as IOpenWithFaire } from "@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaire";

export const useSignUpOwFApplicationStatus = () => {
  const owfApplication = useSignUpOwFApplication();

  const isEligible = owfApplication?.status === IOpenWithFaire.Status.ELIGIBLE;
  const hasApplicationInProgress =
    owfApplication?.status === IOpenWithFaire.Status.APPLICATION_IN_PROGRESS;

  return {
    canApply: isEligible || hasApplicationInProgress,
  };
};
